export default __webpack_public_path__ + "static/project_statement-5e70ff5fa5d64e8544ae390a1f26cd36.png";